import { API_URL } from "@/config";
import { axios } from '@/lib/axios';

import { TokenResponse, AuthProfile } from '@/types';

export type LoginCredentialsDTO = {
    email: string;
    password: string;
};

export const loginWithEmailAndPassword = (data: LoginCredentialsDTO): Promise<TokenResponse> => {
    return axios.post(`${API_URL}/api/admin/security/get_access_token`, data);
};

export const loginWithGoogle = (token: string): Promise<TokenResponse> => {
    return axios.post(`${API_URL}/api/admin/security/google/signin`, { token });
};

export const loginWithMicrosoft = (token: string): Promise<TokenResponse> => {
    return axios.post(`${API_URL}/api/admin/security/microsoft/signin`, { token });
};

export const refreshAccessToken = (refreshToken: string): Promise<TokenResponse> => {
    return axios.post(`${API_URL}/api/admin/security/refresh_access_token`, {refreshToken});
};

export const getProfile = (): Promise<AuthProfile> => {
    return axios.get(`${API_URL}/api/admin/profile`);
};
